import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'None' },
    { value: 2, label: 'Emoji' },
    { value: 3, label: 'Hands' },
  ],
});
